const imprint = {
  title: 'Impressum',
  intro:
    'gut geregelt è un produttore di software svizzero e fa parte del gruppo Betascale.',
  headquarter: 'Sede centrale',
};

export default imprint;
